import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { normalizeWorkerTags } from '@app/pages/admin/worker-tags-page/worker-tags.util';

@Component({
  selector: 'app-process-admission-facts',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './process-admission-facts.html',
  styleUrl: './process-admission-facts.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProcessAdmissionFactsComponent {
  readonly maxConcurrentAssignments = input<number | null | undefined>(null);
  readonly tags = input<readonly string[] | null | undefined>([]);

  readonly capped = computed(() => (this.maxConcurrentAssignments() ?? 0) > 0);
  readonly capCount = computed(() => this.maxConcurrentAssignments() ?? 0);
  readonly visibleTags = computed(() => normalizeWorkerTags(this.tags()));
}
